module.exports = __webpack_public_path__ + "static/media/chuilto.6004cb85.svg";